import styled from "styled-components";

export const MailTokenViewContainer = styled.div`
  background: #fff;
  min-height: 100vh;
  padding: 0;
  position: relative;
`;

export const Header = styled.div`
  padding: 2rem 2rem 1rem 2rem;
  background: #fff;
`;

export const Title = styled.h1`
  margin: 0 0 0.5rem 0;
  font-size: 1.75rem;
  font-weight: 700;
  color: #ff6b35;
`;

export const Description = styled.p`
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
`;

export const HeaderActions = styled.div`
  display: flex;
  gap: 0.75rem;
  margin-bottom: 10px;
  
  @media (max-width: 768px) {
    position: relative;
    top: auto;
    right: auto;
    margin-top: 1rem;
    justify-content: flex-end;
  }
`;

export const TabContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: transparent;
  padding: 1rem 2rem 0 2rem;
  overflow-x: auto;
  border-bottom: 1px solid #e0e0e0;
  
  &::-webkit-scrollbar {
    height: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }
`;

export const Tab = styled.button`
  padding: 0.75rem 2rem;
  background: ${(props) => (props.active ? "#1BACE4" : "#C8C8C8")};
  color: ${(props) => (props.active ? "white" : "#666")};
  border: none;
  border-radius: 8px 8px 0 0;
  cursor: pointer;
  font-size: 15px;
  font-weight: ${(props) => (props.active ? "600" : "500")};
  white-space: nowrap;
  transition: all 0.2s ease;
  min-height: 44px;
  
  &:hover {
    background: ${(props) => (props.active ? "#1589b6" : "#B0B0B0")};
  }
  
  &:focus {
    outline: none;
  }
`;

export const AddTabButton = styled.button`
  padding: 0.5rem;
  background: transparent;
  color: #1BACE4;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  
  &:hover {
    opacity: 0.7;
  }
  
  &:focus {
    outline: none;
  }
  
  img {
    width: 24px;
    height: 24px;
  }
`;

export const CountryDropdown = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 1000;
  margin-top: 0.25rem;
`;

export const CountryDropdownItem = styled.div`
  padding: 0.75rem 1rem;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  transition: background 0.2s ease;
  
  &:hover {
    background: #f0f0f0;
  }
  
  &:not(:last-child) {
    border-bottom: 1px solid #e0e0e0;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  gap: 2rem;
  padding: 2rem;
  
  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;

export const FormSection = styled.div`
  flex: 1;
  min-width: 0;
`;

export const FormRow = styled.div`
  margin-bottom: 1rem;
  
  .ck-editor__editable {
    min-height: 300px;
    max-height: 500px;
  }
`;

export const SidebarContainer = styled.div`
  width: 280px;
  flex-shrink: 0;
  
  @media (max-width: 1024px) {
    width: 100%;
  }
`;

export const VariablesSection = styled.div`
  background: #8CE1FF4D;
  box-shadow: 4px 4px 4px 0px #00000040;
  border-radius: 4px;
  padding: 1rem;
  position: sticky;
  top: 2rem;
  
  h3 {
    margin: 0 0 0.75rem 0;
    font-size: 14px;
    font-weight: 700;
    color: #1e3a5f;
  }
  
  > p {
    display: none;
  }
  
  @media (max-width: 1024px) {
    position: static;
  }
`;

export const VariableCategory = styled.div`
  font-weight: 700;
  color: #1BACE4;
  margin-top: 0.75rem;
  margin-bottom: 0.25rem;
  font-size: 12px;
  text-transform: capitalize;
  
  &:first-child {
    margin-top: 0;
  }
`;

export const VariablesList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 0.5rem 0;
`;

export const VariableItem = styled.li`
  padding: 0.15rem 0;
  font-size: 11px;
  color: #333;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  word-break: break-all;
  line-height: 1.4;
  user-select: none;
  
  &:hover {
    color: #1BACE4;
    cursor: pointer;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
  padding: 1.5rem 2rem;
  background: #f5f5f5;
  border-top: 1px solid #ddd;
  position: sticky;
  bottom: 0;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns:${(props) => props.column};
  gap: ${(props) => (props?.gap ? props.gap : "1rem")};
  opacity: ${(props) => (props?.opacity ? props.opacity : 1)};
  font-size: 14px;
}
`;

export const EditorModeTabs = styled.div`
  display: flex;
  gap: 0.25rem;
  margin-bottom: 0.5rem;
`;

export const EditorModeTab = styled.button`
  padding: 0.4rem 1rem;
  background: ${(props) => (props.active ? "#1BACE4" : "#f0f0f0")};
  color: ${(props) => (props.active ? "white" : "#666")};
  border: 1px solid ${(props) => (props.active ? "#1BACE4" : "#ddd")};
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  font-weight: ${(props) => (props.active ? "600" : "500")};
  transition: all 0.2s ease;

  &:hover {
    background: ${(props) => (props.active ? "#1589b6" : "#e0e0e0")};
  }

  &:focus {
    outline: none;
  }
`;

export const TreeNode = styled.div`
  margin-left: ${(props) => props.depth * 12}px;
`;

export const TreeNodeHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 0.35rem 0.5rem;
  background: ${(props) => props.isRoot ? '#8CE1FF4D' : 'transparent'};
  border-radius: 2px;
  margin-top: ${(props) => props.isRoot ? '0.75rem' : '0.25rem'};
  margin-bottom: 0.25rem;
  cursor: pointer;
  
  &:hover {
    background: ${(props) => props.isRoot ? '#8CE1FF80' : '#f0f0f0'};
  }
`;

export const TreeNodeIcon = styled.span`
  margin-right: 6px;
  font-size: 10px;
  color: #666;
  width: 12px;
  display: inline-block;
`;

export const TreeNodeLabel = styled.span`
  font-weight: ${(props) => props.isRoot ? '600' : '500'};
  font-size: 11px;
  color: ${(props) => props.isRoot ? '#1BACE4' : '#555'};
`;

export const TreeNodeBadge = styled.span`
  margin-left: 6px;
  font-size: 9px;
  color: #999;
  font-weight: normal;
`;

export const TreeNodeChildren = styled.div`
  border-left: 1px solid #e0e0e0;
  margin-left: 6px;
  padding-left: 8px;
`;
